export default __webpack_public_path__ + "static/media/gallery - everlasting elixirs_00.4c61b9ae.jpg";